export default "__VITE_ASSET__9jiMAcqv__"